import React, { FC, useEffect, useState } from "react";
import CustomTable from "../atoms/CustomTable";
import SectionHeader from "../molecules/SectionHeader";
import MainLayout from "../../Layouts/MainLayout";
import ArchiveIcon from "../../static/images/Archive.svg";
import { useLocation, useParams, useNavigate } from "react-router-dom";
import axios from "../../../config/axios";
import { format, parseISO } from "date-fns";
import Spinner from "../atoms/Spinner";
import { service } from "../../../services/AxiosServices";
import WindowHeightComponent from "../../Layouts/WindowHeight";
import { toast } from "react-toastify";
import { usePhase } from "../../../context/PhaseContext";
import ConfirmDialog from "../atoms/ConfirmDialog";
import AccessControl from "../molecules/AccessControl";
import AccessDenied from "../atoms/AccessDenied";
import useAccessCheckLoading from "../../../utils/useAccessCheckLoading";
interface Training {
  id: string;
  instruction?: string;
  documents: JSX.Element;
  uploaded_by?: string;
  time: string;
  uploaded_on: string;
}

const TrainingRecordsPage: FC = () => {
  const [showCompleteDialog, setShowCompleteDialog] = useState(false);
  const [showRevertDialog, setShowRevertDialog] = useState(false);
  const [showDelete, setShowDelete] = useState(false);
  const [showRecordDelete, setRecordDelete] = useState(false);
  const [deleteTrainingId, setDeleteTrainingId] = useState("");
  const location = useLocation();
  const navigate = useNavigate();
  const { id } = useParams();
  const { getPhase, fetchPhase, fetchTrainingRecords, trainingRecords } =
    usePhase();
  console.log(trainingRecords);

  const crewAnalyzedRecords = location.pathname.includes(
    "/crew-analyzed-records"
  );
  const crewPreparedRecords = location.pathname.includes(
    "/crew-prepared-records"
  );

  const spaceAnalyzedRecords = location.pathname.includes(
    "/space-analyzed-records"
  );
  const spacePreparedRecords = location.pathname.includes(
    "/space-prepared-records"
  );
  const trainingSpace = location.pathname.includes("/training");
  const trainingCrew = location.pathname.includes("/trained-crews");

  const analyzedRecords = crewAnalyzedRecords || spaceAnalyzedRecords;
  const preparedRecords = crewPreparedRecords || spacePreparedRecords;
  const trainingUrl =
    trainingSpace || analyzedRecords || preparedRecords || trainingCrew;

  const phaseCategory =
    crewAnalyzedRecords || crewPreparedRecords || trainingCrew
      ? "crew"
      : spaceAnalyzedRecords || spacePreparedRecords || trainingSpace
      ? "knowledge_hub"
      : "";
  const currentPhase = getPhase(Number(id));
  useEffect(() => {
    if (id) {
      fetchPhase(Number(id), phaseCategory);
    }
  }, [id]);

  const title = analyzedRecords
    ? "Document for analysis"
    : preparedRecords
    ? "Document for preparation"
    : "Manage knowledge hub";

  const [training, setTraining] = useState<any[]>([]);
  const [loading, setLoading] = useState<boolean>(true);

  const accessCheckLoading = useAccessCheckLoading();

  useEffect(() => {
    const fetchTrainingDetails = async () => {
      try {
        setLoading(true);

        const endPoint = analyzedRecords
          ? "api/fetch-analyse-docs/"
          : preparedRecords
          ? "api/fetch-prepare-docs/"
          : trainingSpace || trainingCrew
          ? "/api/get-all-ai-space-training-details"
          : "";

        let payload =
          analyzedRecords || preparedRecords
            ? {
                entity_id: id,
                entity_type:
                  spaceAnalyzedRecords || spacePreparedRecords
                    ? "Knowledge hub"
                    : "Crew",
              }
            : {
                ...(trainingSpace
                  ? { space_id: id }
                  : trainingCrew
                  ? { crew_id: id }
                  : {}),
                project_id: localStorage.getItem("project_id"),
              };

        const response = await service<{ data: any[] }>(
          endPoint,
          "post",
          payload
        );
        const responseData = response?.data?.data || [];
        if (analyzedRecords && id) {
          fetchTrainingRecords(Number(id), response?.data?.data || []);
        }

        if (analyzedRecords || preparedRecords) {
          setTraining(
            responseData
              .map((record: any) => ({
                id: record?.id,
                document: (
                  <div>
                    {record?.documents?.map((doc: any) => (
                      <a
                        key={doc?.id}
                        href={`${axios.defaults.baseURL}${doc?.file}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="block pe-3"
                      >
                        {doc?.file.replace("/media/uploads/", "")}
                      </a>
                    ))}
                  </div>
                ),
                uploadedBy: "Admin",
                time: format(parseISO(record?.created_at), "HH:mm"),
                uploadedOn: format(parseISO(record?.created_at), "dd-MM-yyyy"),
              }))
              .sort((a: any, b: any) =>
                String(b.id).localeCompare(String(a.id))
              )
          );
        } else {
          setTraining(
            responseData
              .map((record: any) => ({
                id: record?.id,
                instruction: record?.instruction,
                document: (
                  <div>
                    {record?.documents?.map((doc: any) => (
                      <a
                        key={doc?.id}
                        href={`${axios.defaults.baseURL}${doc?.file}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="block pe-3"
                      >
                        {doc?.file.replace("/media/uploads/", "")}
                      </a>
                    ))}
                  </div>
                ),
                uploadedBy: "Admin",
                time: format(parseISO(record?.uploaded_on), "HH:mm"),
                uploadedOn: format(parseISO(record?.uploaded_on), "dd-MM-yyyy"),
              }))
              .sort((a: any, b: any) =>
                String(b.id).localeCompare(String(a.id))
              )
          );
        }
      } catch (err) {
        console.error("Error fetching training details:", err);
        toast.error("Failed to fetch training details");
      } finally {
        setLoading(false);
      }
    };

    fetchTrainingDetails();
  }, [id, analyzedRecords, preparedRecords, trainingSpace]);

  const handleDelete = async (trainingId: string) => {
    setDeleteTrainingId(trainingId);
    setShowDelete(true);
  };

  const confirmDelete = async (trainingId: string) => {
    setDeleteTrainingId(trainingId);
    setTraining((prev) => prev.filter((ele) => ele.id !== trainingId));
    try {
      await service<any>("api/delete-training-data/", "post", {
        id: trainingId,
        project_id: localStorage.getItem("project_id"),
        ...(trainingSpace ? { ai_space_id: id } : { crew_id: id }),
      });
      toast.success("Knowledge history deleted successfully", {
        autoClose: 2000,
      });
    } catch (err) {
      console.error("Delete Error:", err);
      toast.warning("Something went wrong");
    } finally {
      setDeleteTrainingId("");
      setShowDelete(false);
    }
  };

  const handleRecords = async (trainingId: string) => {
    setDeleteTrainingId(trainingId);
    setRecordDelete(true);
  };

  const confirmRecordsDelete = async (trainingId: string) => {
    setTraining((prev) => prev.filter((ele) => ele.id !== trainingId));
    try {
      const endPoint = analyzedRecords
        ? "api/delete-analyse-document/"
        : preparedRecords
        ? "api/delete-prepare-document/"
        : "";
      const entityType =
        crewPreparedRecords || crewAnalyzedRecords
          ? "Crew"
          : spacePreparedRecords || spaceAnalyzedRecords
          ? "Knowledge hub"
          : "";
      const toastMessage = analyzedRecords
        ? "Analyzed records"
        : preparedRecords
        ? "Prepared records"
        : "";

      // await axios.delete(endPoint, {
      //   data: { entity_id: trainingId, entity_type: entityType },
      //   headers: { 'Content-Type': 'application/json' }
      // });

      await service<any>(endPoint, "post", {
        entity_id: id,
        entity_type: entityType,
        phase_id: trainingId,
      });

      toast.success(`${toastMessage} deleted successfully!`, {
        autoClose: 2000,
      });
    } catch (err) {
      console.error("Delete Error:", err);
      toast.warning("Something went wrong");
    } finally {
      setDeleteTrainingId("");
      setRecordDelete(false);
    }
  };

  const handleAdd = () => {
    if (trainingSpace) navigate(`/training-space/${id}/upload`);
    else if (crewPreparedRecords) navigate(`/crew-prepare/${id}/upload`);
    else if (crewAnalyzedRecords) navigate(`/crew-analyze/${id}/upload`);
    else if (spacePreparedRecords) navigate(`/space-prepare/${id}/upload`);
    else if (spaceAnalyzedRecords) navigate(`/space-analyze/${id}/upload`);
    else navigate(`/training-crew/${id}/upload`);
  };
  const columns =
    analyzedRecords || preparedRecords
      ? ["Document", "Time", "Uploaded on"]
      : ["Document", "Uploaded by", "Time", "Uploaded on"];

  const phaseCheck = () => {
    let phase;
    if (analyzedRecords) {
      phase = 0;
    } else if (preparedRecords) {
      phase = 1;
    } else if (trainingCrew || trainingSpace) {
      phase = 3;
    }
    return phase;
  };

  const handleComplete = async () => {
    setShowCompleteDialog(true);
  };

  const confirmComplete = async () => {
    let phase = phaseCheck();
    if (currentPhase === phase) {
      const toastMessage = analyzedRecords
        ? "Analyze phase"
        : preparedRecords
        ? "Prepare phase"
        : "Training";

      try {
        const formData = {
          entity_id: id,
          entity_type: phaseCategory,
          phase: currentPhase,
          user_id: localStorage.getItem("user"),
        };

        await service<any>(`api/update-phase`, "post", formData);
        fetchPhase(Number(id), phaseCategory);

        toast.success(`${toastMessage}  completed successfully!`, {
          autoClose: 2000,
        });
      } catch (err) {
        console.error(err);
        toast.error("Failed to complete the phase", { autoClose: 2000 });
      }
    } else {
      toast.warning("Please complete previous phase!", { autoClose: 2000 });
    }
  };

  const phaseDetails = () => {
    if (analyzedRecords) {
      return 0;
    } else if (preparedRecords) {
      return 1;
    } else if (trainingCrew || trainingSpace) {
      return 3;
    }
  };
  const handleRevert = async () => {
    setShowRevertDialog(true);
  };
  const confirmRevert = async () => {
    const toastMessage = analyzedRecords
      ? "Analyze phase"
      : preparedRecords
      ? "Prepare phase"
      : "Training";
    try {
      const formData = {
        entity_id: id,
        entity_type: phaseCategory,
        phase: phaseDetails(),
        revert: true,
        user_id: localStorage.getItem("user"),
      };
      await service<any>(`api/update-phase`, "post", formData);
      fetchPhase(Number(id), phaseCategory);
      toast.success(`${toastMessage} reverted successfully!`, {
        autoClose: 2000,
      });
    } catch (err) {
      console.log(err);
      toast.error("Failed to revert phase", { autoClose: 2000 });
    }
  };

  return (
    <MainLayout>
      <AccessControl
        requiredPermissions={[
          {
            permission: crewAnalyzedRecords
              ? "crew_analyze_documents"
              : spaceAnalyzedRecords
              ? "analyze_documents"
              : crewPreparedRecords
              ? "prepare_document"
              : spacePreparedRecords
              ? "prepare_documents"
              : trainingCrew
              ? "training"
              : trainingSpace
              ? "knowledge_hub"
              : "",
            types: ["read"],
          },
        ]}
        renderNoAccess={ accessCheckLoading ? <Spinner/> :<AccessDenied />}
      >
        <SectionHeader
          complete={handleComplete}
          phase={currentPhase}
          crewAnalyzedRecords={crewAnalyzedRecords}
          crewPreparedRecords={crewPreparedRecords}
          spaceAnalyzedRecords={spaceAnalyzedRecords}
          spacePreparedRecords={spacePreparedRecords}
          trainingSpace={trainingSpace}
          trainingCrew={trainingCrew}
          permissionName={
            crewAnalyzedRecords
              ? "crew_analyze_documents"
              : spaceAnalyzedRecords
              ? "analyze_documents"
              : crewPreparedRecords
              ? "prepare_document"
              : spacePreparedRecords
              ? "prepare_documents"
              : trainingCrew
              ? "training"
              : trainingSpace
              ? "knowledge_hub"
              : ""
          }
          permissionTypes={["create"]}
          back={true}
          title={title}
          onAdd={handleAdd}
          revert={handleRevert}
          action={
            analyzedRecords || preparedRecords
              ? "Upload document"
              : "Knowledge hub"
          }
        />
        <ConfirmDialog
          show={showCompleteDialog}
          onHide={() => setShowCompleteDialog(false)}
          onConfirm={confirmComplete}
          title="Confirm complete"
          body="Are you sure you want to complete this phase"
          confirmText="Complete"
        />

        {/* Confirm Revert Dialog */}
        <ConfirmDialog
          show={showRevertDialog}
          onHide={() => setShowRevertDialog(false)}
          onConfirm={confirmRevert}
          title="Confirm revert"
          body="Are you sure you want to revert this phase?"
          confirmText="Revert"
        />

        <ConfirmDialog
          show={showDelete}
          onHide={() => setShowDelete(false)}
          onConfirm={() => confirmDelete(deleteTrainingId)}
          title="Confirm delete"
          body="Are you sure?"
          confirmText="Delete"
        />

        <ConfirmDialog
          show={showRecordDelete}
          onHide={() => setRecordDelete(false)}
          onConfirm={() => confirmRecordsDelete(deleteTrainingId)}
          title="Confirm delete"
          body="Are you sure?"
          confirmText="Delete"
        />

        <WindowHeightComponent className={""}>
          <div className="p-3">
            {loading ? (
              <Spinner />
            ) : training.length === 0 ? (
              <p className="text-center mt-4 text-danger">No result found</p>
            ) : (
              <CustomTable
                rows={training}
                columns={["Document", "Uploaded by", "Time", "Uploaded on"]}
                actionButtons={[
                  {
                    icon: ArchiveIcon,
                    alt: "Delete",
                    onClick: (rowIndex: number) =>
                      analyzedRecords || preparedRecords
                        ? handleRecords(training[rowIndex]?.id)
                        : handleDelete(training[rowIndex]?.id),
                  },
                ]}
                trainingUrl={trainingUrl}
                permission={
                  crewAnalyzedRecords
                    ? "crew_analyze_documents"
                    : spaceAnalyzedRecords
                    ? "analyze_documents"
                    : crewPreparedRecords
                    ? "prepare_document"
                    : spacePreparedRecords
                    ? "prepare_documents"
                    : trainingCrew
                    ? "training"
                    : trainingSpace
                    ? "knowledge_hub"
                    : ""
                }
              />
            )}
          </div>
        </WindowHeightComponent>
      </AccessControl>
    </MainLayout>
  );
};

export default TrainingRecordsPage;
